export default {
  "nearby": "Cerca de mí",
  "alerts": "Alertas",
  "explore": "Explorar",
  "cart": "Carrito",
  "account": "Cuenta",
  "services": "Servicios",
  "foodQuestion": "¿Qué deseas pedir?",
  "foodSearch": "Busca negocios, platos y productos",
  "nearYou": "CERCA DE TI",
  "chooseLocation": "Selecciona tu ubicación",
  "chooseLocationHelp": "La necesitamos para mostrarte los negocios que entregan en tu zona.",
  "chooseAddress": "Elegir dirección",
  "changeZone": "Cambiar zona",
  "searchingStores": "Buscando negocios…",
  "storesAvailable": "negocios disponibles",
  "noStores": "No hay restaurantes disponibles en tu zona.",
  "newStores": "Negocios nuevos",
  "justArrived": "RECIÉN LLEGADOS",
  "newLabel": "Nuevo",
  "recommendedLabel": "Recomendado",
  "popularLabel": "Popular",
  "recommendedEyebrow": "LOS FAVORITOS DEL NEGOCIO",
  "recommendedProducts": "Recomendados",
  "addProduct": "Agregar",
  "openNow": "Abierto",
  "closedNow": "Cerrado",
  "exploreTitle": "Busca lo que deseas",
  "exploreHelp": "Encuentra negocios, platos y productos disponibles en tu zona.",
  "searchThreeChars": "Escribe al menos 3 letras para buscar.",
  "searching": "Buscando…",
  "noSearchResults": "No encontramos resultados.",
  "businesses": "Negocios",
  "viewMenu": "Ver carta",
  "servicesTitle": "Servicios para ti",
  "servicesHelp": "Elige un servicio disponible sin salir del aplicativo.",
  "loadingServices": "Cargando servicios…",
  "enterService": "Solicitar servicio",
  "anotherAddress": "Prueba seleccionando otra dirección.",
  "loadingMenu": "Cargando la carta…",
  "backStores": "Volver a negocios",
  "searchMenu": "Buscar en esta carta",
  "noProducts": "No encontramos productos",
  "anotherWord": "Prueba con otra palabra.",
  "minimumOrder": "Pedido mín.",
  "products": "Productos",
  "viewCart": "Ver carrito",
  "yourOrder": "TU PEDIDO",
  "emptyCart": "Tu carrito está vacío",
  "emptyCartHelp": "Agrega productos de un negocio para comenzar tu pedido.",
  "browseStores": "Explorar negocios",
  "subtotal": "Subtotal",
  "deliveryCheckout": "La tarifa de entrega se calculará con tu dirección en el checkout.",
  "checkoutContinue": "Continuar al checkout",
  "confirmOrder": "Confirmar pedido",
  "backCart": "Volver al carrito",
  "deliverAt": "ENTREGA EN",
  "change": "Cambiar",
  "reference": "Número, piso o referencia",
  "orderNote": "Nota para el negocio",
  "payment": "Forma de pago",
  "cash": "Efectivo al recibir",
  "selected": "Seleccionado",
  "estimatedDelivery": "Envío estimado",
  "total": "Total",
  "loginFinish": "Inicia sesión para finalizar",
  "loginContinue": "Iniciar sesión y continuar",
  "tracking": "SEGUIMIENTO",
  "myOrders": "Mis pedidos",
  "loginOrders": "Inicia sesión para ver tus pedidos",
  "noOrders": "Aún no tienes pedidos",
  "profile": "PERFIL",
  "myAccount": "Mi cuenta",
  "login": "Iniciar sesión",
  "register": "Crear cuenta",
  "name": "Nombre",
  "phone": "WhatsApp / teléfono",
  "email": "Correo electrónico",
  "password": "Contraseña",
  "enter": "Entrar",
  "registerMe": "Registrarme",
  "language": "Idioma",
  "languageHelp": "Se aplica a todas las secciones nuevas",
  "notifications": "Notificaciones",
  "notificationsHelp": "Pedidos, promociones y novedades",
  "notificationsEnabled": "Activadas en este dispositivo",
  "notificationsBlocked": "Bloqueadas en el navegador",
  "notificationsBlockedHelp": "El permiso fue bloqueado. Ábrelo desde el candado o los ajustes del sitio y permite las notificaciones.",
  "notificationsUnsupported": "Este navegador no admite notificaciones",
  "notificationsError": "No se pudo solicitar el permiso. Inténtalo nuevamente.",
  "activate": "Activar",
  "review": "Revisar permiso",
  "logout": "Salir",
  "history": "Historial y seguimiento",
  "whereDeliver": "¿Dónde entregamos?",
  "sharedAddress": "La dirección se compartirá con restaurantes, envíos y próximos servicios.",
  "currentLocation": "Usar mi ubicación actual",
  "locating": "Buscando tu ubicación…",
  "popularPlaces": "LUGARES POPULARES",
  "selectAddress": "Selecciona tu dirección",
  "allInOne": "TODO EN UN SOLO LUGAR",
  "exploreHuaraz": "Explora Huaraz",
  "portalSub": "Comida, envíos y nuevos servicios cerca de ti.",
  "restaurants": "Restaurantes",
  "taxiLabel": "Taxi",
  "supermarket": "Supermercado",
  "orderFood": "Pide comida y productos",
  "soon": "Próximamente",
  "available": "Disponible",
  "navBusinesses": "Negocios",
  "navJoin": "Únete",
  "heroTitle": "Todo Huaraz, directo a tu puerta",
  "heroDescription": "Descubre restaurantes, antojos y negocios locales. Haz tu pedido en pocos pasos y recíbelo donde estés.",
  "choose": "Elige",
  "favoriteBusiness": "tu negocio favorito",
  "order": "Pide",
  "easySecure": "fácil y seguro",
  "receive": "Recibe",
  "atYourLocation": "en tu ubicación",
  "exploreFromPc": "Explorar desde mi PC",
  "localBusinesses": "Negocios locales",
  "deliveryInHuaraz": "Entrega en Huaraz",
  "orderTracking": "Seguimiento del pedido",
  "liveApp": "App en vivo",
  "shopHere": "Puedes comprar aquí mismo",
  "shipments": "Envíos",
  "openApp": "Abrir la aplicación",
  "dailyServices": "Servicios para tu día a día",
  "dailyServicesDescription": "Compra, envía y descubre opciones locales desde una sola plataforma.",
  "restaurantServiceDescription": "Pide comida y productos de los mejores negocios locales.",
  "exploreBusinesses": "Explorar negocios",
  "pickupDelivery": "Recojo y entrega",
  "pickupDescription": "Llevamos tu paquete desde el punto A hasta el punto B.",
  "requestDelivery": "Solicitar un envío",
  "taxiDescription": "Solicita movilidad de manera rápida y segura.",
  "temporarilyUnavailable": "Temporalmente no disponible",
  "requestTaxi": "Solicitar taxi",
  "verySoon": "Muy pronto",
  "buyLocal": "COMPRA LOCAL",
  "meetBusinesses": "Conoce nuestros negocios",
  "previousBusinesses": "Negocios anteriores",
  "nextBusinesses": "Siguientes negocios",
  "growTogether": "CRECEMOS CONTIGO",
  "joinDelivery": "Forma parte de Delivery Huaraz",
  "joinDescription": "Herramientas para vender, repartir y gestionar tu operación desde una plataforma creada para Huaraz.",
  "forBusinesses": "PARA NEGOCIOS",
  "growSales": "Haz crecer tus ventas",
  "growSalesDescription": "Recibe pedidos, administra tu carta y llega a más clientes sin perder el control de tu operación.",
  "registerBusiness": "Registrar mi negocio",
  "forDrivers": "PARA MOTORIZADOS",
  "earnDelivering": "Genera ingresos repartiendo",
  "driverDescription": "Recibe pedidos, envíos y alertas desde una herramienta integrada para trabajar en movimiento.",
  "applyDriver": "Postular como motorizado",
  "footerDescription": "Comida, envíos y servicios locales en un solo lugar.",
  "enterApp": "Entrar a la aplicación",
  "closeApp": "Cerrar aplicación",
  "gpsPrompt": "Activar el GPS garantizará una dirección precisa y una entrega sin problemas.",
  "shopping": "Compras",
  "events": "Eventos",
  "mobileJoinDescription": "Negocios y motorizados cuentan con sus propias herramientas, alertas y paneles de trabajo.",
  "haveBusiness": "¿Tienes un negocio?",
  "mobileBusinessDescription": "Recibe pedidos, administra tu carta y llega a más clientes de Huaraz.",
  "haveMotorcycle": "¿Tienes moto?",
  "mobileDriverDescription": "Genera ingresos con pedidos, envíos y nuevos servicios desde el panel integrado.",
  "myAddresses": "Mis direcciones",
  "addressHelp": "Casa, trabajo, hotel y más",
  "walletCredits": "Billetera y créditos",
  "walletHelp": "Saldos, recargas y beneficios",
  "myFavorites": "Mis favoritos",
  "favoriteHelp": "Negocios que guardaste",
  "myCart": "Mi carrito",
  "cartHelp": "Continuar con mi compra",
  "helpInfo": "Ayuda e información",
  "helpInfoDesc": "Preguntas, políticas y términos",
  "forgotPassword": "Olvidé mi contraseña",
  "favoriteTitle": "Negocios favoritos",
  "favoriteLogin": "Inicia sesión para guardar tus favoritos",
  "noFavoritesZone": "No tienes negocios favoritos en tu zona",
  "favoriteEmptyHelp": "Guarda los que más te gustan desde su carta.",
  "reviews": "OPINIONES",
  "backMenu": "Volver a la carta",
  "noReviews": "Aún no hay opiniones publicadas.",
  "infoTitle": "Ayuda e información",
  "recoverAccess": "RECUPERAR ACCESO",
  "newPassword": "Nueva contraseña",
  "recoverHelp": "Recibirás un código en el correo registrado en Delivery Huaraz.",
  "sendCode": "Enviar código",
  "verifyCode": "Verificar código",
  "savePassword": "Guardar contraseña",
  "cartProductsTitle": "Productos en el carrito",
  "clearCart": "Vaciar",
  "decreaseQuantity": "Reducir cantidad o eliminar producto",
  "increaseQuantity": "Aumentar cantidad",
  "cartCommentPlaceholder": "Escribe un comentario o indicación para el negocio…",
  "coupon": "Cupón",
  "applyCoupon": "Aplicar",
  "couponInvalid": "El cupón no es válido.",
  "discountApplied": "Descuento aplicado",
  "paymentDetails": "Detalle de pago",
  "deliveryFee": "Tarifa de entrega",
  "businessCharge": "Cargo del negocio",
  "discount": "Descuento",
  "totalToPay": "Total a pagar",
  "confirmDeliveryAddress": "CONFIRMA TU DIRECCIÓN DE ENTREGA",
  "selectAnAddress": "Selecciona una dirección",
  "verifyCurrentAddress": "Verifica que el pedido llegue al lugar donde te encuentras ahora.",
  "addressConfirmed": "Dirección confirmada",
  "correctAddress": "Sí, esta es la dirección correcta",
  "confirmAddressHelp": "Debes confirmarla para continuar con el pago",
  "continuePayment": "Continuar al pago",
  "fulfillmentQuestion": "¿Cómo deseas recibir tu pedido?",
  "deliveryOption": "Delivery",
  "deliveryOptionHelp": "Lo llevamos a tu dirección",
  "pickupOption": "Recojo en local",
  "pickupOptionHelp": "Recógelo cuando esté listo",
  "pickupAtStore": "Recojo en el negocio",
  "pickupAddressHelp": "Consulta la dirección del negocio",
  "pickupReadyHelp": "El negocio te avisará cuando el pedido esté listo.",
  "noCost": "Sin costo",
  "noDeliveryFee": "Sin tarifa de delivery",
  "howPayPickup": "¿Cómo pagarás al recoger tu pedido?",
  "howPayDelivery": "¿Cómo pagarás al recibir tu pedido?",
  "paymentMethodForLocation": "Método de pago disponible para su ubicación",
  "payOnDeliveryLabel": "PAGO AL RECIBIR",
  "payOnDeliveryTitle": "Efectivo, Yape o Plin",
  "payOnDeliveryHelp": "Selecciona cómo pagarás cuando llegue tu pedido.",
  "choosePayment": "Elegir",
  "choosePaymentOnDelivery": "Elige cómo pagarás al recibir",
  "confirmAddressTitle": "Confirma tu dirección",
  "addressMapInstructions": "Usa el GPS y después mueve el marcador exactamente hasta la puerta de entrega.",
  "savedAddressesTitle": "MIS DIRECCIONES GUARDADAS",
  "genericAddress": "Dirección",
  "useGpsNow": "Usar mi GPS ahora",
  "gpsUnsupported": "Este dispositivo no permite obtener el GPS.",
  "gpsPermissionRequired": "Necesitamos permiso de ubicación para usar tu GPS.",
  "gpsUnavailableHelp": "No pudimos obtener una ubicación precisa. Busca tu calle o mueve el marcador.",
  "gpsAccuracy": "Precisión aproximada",
  "gpsMoveMarker": "Mueve el marcador para corregirla.",
  "gpsConfirmPoint": "Confirma el punto en el mapa.",
  "addressSearchPlaceholder": "Busca calle, avenida, hotel o referencia",
  "search": "Buscar",
  "addressNotFoundHelp": "No encontramos esa dirección. Mueve el marcador hasta tu puerta.",
  "mapNotConfigured": "El mapa todavía no está configurado.",
  "mapLoadFailed": "No se pudo cargar el mapa.",
  "dragMarkerHelp": "Arrastra el marcador hasta tu puerta",
  "addressHouseLabel": "Número, piso o referencia",
  "addressHousePlaceholder": "Ej. Casa azul, puerta 2",
  "saveAs": "Guardar como",
  "homeTag": "Casa",
  "workTag": "Trabajo",
  "hotelTag": "Hotel",
  "otherTag": "Otro",
  "saveInMyAddresses": "Guardar en Mis direcciones",
  "savingAddress": "Guardando…",
  "confirmThisAddress": "Confirmar esta dirección",
  "popularHuarazPlaces": "Lugares conocidos de Huaraz",
  "noStoresAtPoint": "No encontramos negocios para ese punto.",
  "gpsOutsideCoverageHelp": "El GPS puede haberte ubicado fuera de la cobertura. Corrige el marcador hasta tu puerta.",
  "correctMapLocation": "Corregir ubicación en el mapa",
  "checkingCurrentLocation": "Comprobando tu ubicación actual…",
  "checkAddressWithGps": "Comprobar esta dirección con mi GPS",
  "locationVerifiedForOrder": "Ubicación comprobada para este pedido.",
  "gpsMatchesDeliveryAddress": "Tu ubicación actual coincide con la dirección de entrega.",
  "youMayHaveMoved": "Parece que estás en otro lugar",
  "currentLocationDistance": "Tu GPS actual está aproximadamente a {distance} km de la dirección seleccionada.",
  "useCurrentGpsAndAdjust": "Usar mi GPS y ajustar",
  "deliverToSelectedAddress": "Entregar en la dirección seleccionada",
  "gpsNeedsConfirmation": "El GPS necesita tu confirmación",
  "gpsAccuracyTooLow": "La precisión actual es de aproximadamente {accuracy} m. Revisa el punto antes de pedir.",
  "reviewLocationOnMap": "Revisar ubicación en el mapa",
  "gpsCouldNotVerify": "No pudimos comprobar dónde estás",
  "addressVerificationExpired": "Necesitamos comprobar nuevamente la dirección de entrega. Te llevaremos al carrito.",
  "back": "Volver", "close": "Cerrar", "home": "Inicio", "offers": "Ofertas",
  "loadingNavigation": "Cargando navegación", "mainNavigation": "Navegación principal",
  "customizeOrder": "Personaliza tu pedido", "loadingProduct": "Cargando producto…",
  "chooseOptions": "Elige tus opciones", "chooseOneOption": "Elige una opción", "chooseUpTo": "Elige hasta {count}",
  "optional": "Opcional", "additional": "Adicional", "additionals": "Adicionales",
  "continue": "Continuar", "continueAndAdd": "Continuar y agregar por",
  "exclusiveOffers": "OFERTAS EXCLUSIVAS", "yapePromos": "Promos Yape",
  "yapeSpecialPrices": "Precios especiales pagando con Yape.", "yapeLocationHelp": "Para confirmar qué negocios llegan hasta ti.",
  "searchPromoOrBusiness": "Buscar una promo o negocio", "loadingPromotions": "Cargando promociones…",
  "promotionsLoadError": "No pudimos cargar las promociones.", "noYapePromos": "Aún no hay Promos Yape activas.",
  "comeBackForOffers": "Vuelve pronto para ver nuevas ofertas.", "availablePromotions": "Promociones disponibles",
  "yapeOnly": "Solo Yape", "viewMyOrder": "Ver mi pedido", "benefitsForYou": "Beneficios para ti", "seeAll": "Ver todos",
  "exclusiveDiscounts": "Descuentos exclusivos", "accordingToPromotions": "Según promociones",
  "deliveriesAndPickups": "Envíos y recojos", "accordingToCoverage": "Según cobertura",
  "shoppingBenefits": "Beneficios por comprar", "moreNewsSoon": "Más novedades pronto",
  "category": "Categoría", "backToCategories": "Volver a categorías",
  "storesNearLocation": "Negocios disponibles cerca de tu ubicación.", "searchIn": "Buscar en",
  "categoryAddressHelp": "Necesitamos tu dirección para mostrar negocios de esta categoría.", "inYourZone": "EN TU ZONA",
  "loadingBusinesses": "Cargando negocios", "businessesLoadError": "No pudimos cargar los negocios.",
  "noCategoryBusinesses": "No hay negocios de {category} disponibles en tu zona.",
  "discoverMenuPromotions": "Conoce su carta y promociones.",
  "yapeExclusivePayment": "Promo exclusiva pagando con Yape", "yapePromoOrderNotice": "Este pedido contiene una Promo Yape.",
  "exclusivePaymentMethod": "FORMA DE PAGO EXCLUSIVA", "payWithYape": "Pagar con Yape", "keepPromotionalPrice": "Requerido para conservar el precio promocional",
  "integrationPending": "Integración pendiente", "storeClosed": "El negocio está cerrado", "checkoutStoreClosedHelp": "No podrás confirmar este pedido hasta que el negocio vuelva a estar disponible.",
  "selectOptionToContinue": "Selecciona una opción para continuar.", "cash": "Efectivo", "cashChangeHelp": "Indica si necesitas vuelto", "coordinatedTransfer": "Transferencia coordinada",
  "cashAmountPlaceholder": "¿Con cuánto pagarás? Ejemplo: 50", "processing": "Procesando…", "confirmCashOrder": "Confirmar pedido en efectivo",
  "confirmOrderWith": "Confirmar pedido con {method}", "cashChangeInstructions": "Si necesitas vuelto, escribe el valor del billete. Si pagarás exacto, puedes dejarlo vacío.",
  "transferPickupInstructions": "No se cobrará dentro de la app. Confirma los datos de {method} con el negocio antes de transferir.",
  "transferDeliveryInstructions": "No se cobrará dentro de la app. Confirma los datos de {method} con el negocio o el motorizado antes de transferir.",
  "selectPaymentMethod": "Selecciona una forma de pago", "storeActions": "Acciones del negocio", "searchProducts": "Buscar productos", "shareStore": "Compartir negocio",
  "storeClosedMenuHelp": "Fuera del horario de atención. Puedes revisar el menú.", "closeNotice": "Cerrar aviso",
  "searchInStore": "Buscar en {store}", "storeCategories": "Categorías del negocio", "customizable": "Personalizable", "added": "Añadido",
  "productDetail": "Detalle del producto", "customizeAndAdd": "Personalizar y agregar", "addToOrder": "Agregar al pedido", "addedToCart": "Añadido al carrito",
  "storeNotAcceptingOrders": "Este negocio está cerrado y no acepta pedidos en este momento."
};
